
<mat-sidenav-container class="maincontentheight">
    <mat-sidenav *ngIf="settings.menu == 'vertical'" [opened]="settings.sidenavIsOpened" [mode]="(settings.sidenavIsPinned) ? 'side' : 'over'" #sidenav class="sidenav mat-elevation-z6" style="overflow-y: auto !important;" >
        <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav-content id="main">
        <mat-toolbar color="primary" class="flex-p-x">
            <div style="display:flex; justify-content: space-between; align-items: center; overflow-y: auto !important;" class="w-100">            
                <div style="display: flex; justify-content: center; align-items: center;">                    
                    <button *ngIf="settings.menu == 'vertical'" mat-icon-button (click)="toggleSidenav()" matTooltip="{{'Menu.Tooltips.Hide-Sidebar' | translate}}">
                        <mat-icon >menu</mat-icon>
                    </button> 
                    <a class="logo" routerLink="/" (click)="closeSubMenus()">{{ 'General.Application.Title' | translate }}</a> 
                    <button fxShow="false" fxShow.gt-xs *ngIf="settings.menu == 'vertical'" mat-icon-button matTooltip="{{'Menu.Tooltips.Hide-User' | translate}}" (click)="settings.sidenavUserBlock = !settings.sidenavUserBlock">
                        <mat-icon >person</mat-icon>
                    </button>
                </div>            
                <div style="display:flex; justify-content: end; align-items: center;">
                    <div *ngIf="currentRoute == '/my-appointments'" joyrideStep="Tutorial" title="{{ 'Tutorial.My-Appointments.Tutorial-Menu-Title' | translate}}"
                        text="{{ 'Tutorial.My-Appointments.Tutorial-Menu-Text' | translate}}" (done)="stopTutorial('my-appointments')">
                        <button mat-icon-button fxShow.gt-sm matTooltip="{{'Menu.Tooltips.Show-Tutorial' | translate }}" (click)="showTutorial()">
                            <mat-icon>help</mat-icon>
                        </button>
                    </div>
                    <app-flags-menu fxShow="false" fxShow.gt-sm matTooltip="{{'Menu.Tooltips.Show-Languages' | translate }}"></app-flags-menu>
                    <app-applications fxShow="false" fxShow.gt-sm></app-applications>
                    <app-messages fxShow="false" fxShow.gt-xs></app-messages>
                    <app-user-menu id="userSettingsMenu" joyrideStep="UserSettings" title="{{ 'Tutorial.My-Appointments.User-Settings-Title' | translate}}"
                    text="{{ 'Tutorial.My-Appointments.User-Settings-Text' | translate}}" matTooltip="{{'Menu.Tooltips.Personal-Settings' | translate }}" ></app-user-menu> 
                    <button mat-icon-button routerLink="/Logout" matTooltip="{{'Menu.Tooltips.Logout' | translate}}">
                        <mat-icon>power_settings_new</mat-icon>
                    </button>
                </div>
            </div>
        </mat-toolbar>

        <mat-toolbar color="primary" *ngIf="settings.menu == 'horizontal'" 
            class="horizontal-menu flex-p-x transition-2" 
            [class.fixed-top]="!settings.fixedHeader">
            <div style="display: flex; flex-direction: row; justify-content:center; align-items:center;" class="w-100">            
                <app-horizontal-menu [menuParentId]="0"></app-horizontal-menu>
            </div>            
        </mat-toolbar>

        <div id="main-content" class="inner-sidenav-content transition-2" > 
            <router-outlet></router-outlet>    
        </div>

    </mat-sidenav-content>
</mat-sidenav-container>
<app-footer class="footer"></app-footer>